import { get_handlebars_template } from '@/scripts/imports/helpers/handlebars'
import { if_equals } from '@/scripts/imports/helpers/handlebars'

export const tma_add_status_message = (message, type = 'success', icon = '') => {
   let icons = {'success' : 'circle-check', 'danger' : 'circle-exclamation', 'warning' : 'triangle-exclamation', 'info' : 'circle-question'}
   get_handlebars_template({message: message, type: type, icon: icon ? icon : icons[type]}, 'toast').then($content => {
      $('.toast-container').append($content)
      tma_display_toasts()
   })
}

export const tma_display_toasts = () => {
   // Added .ready to make sure it doesn't fire
   // before bootstrap is fully loaded
   $(document).ready(function() {
      if(! $('.toast').length) return

      $('.toast').each(function(index){
         $(this).on('hidden.bs.toast', function(){
            $(this).remove()
         })

         if(! $(this).hasClass('show')){
            $(this).toast('show')
         }
      })
   })
}